// Packages
import { useTheme } from "@mui/material/styles";

// MUI
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@mui/material";

// Icon
import { ReactComponent as CheckedIcon } from "assets/images/icons/icn_checked.svg";
import { ReactComponent as UnCheckedIconIcon } from "assets/images/icons/icn_unchecked.svg";

export const StyledRadioButtonGroup = ({
  showEditGeneral,
  label,
  value,
  isIndent,
  onChange
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        mb: 2,
        ml: isIndent ? 2.5 : 1,
        mt: 2.3,
        color: theme.palette.primary.main,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.customFontSize[5],
        fontWeight: theme.typography.customFontWeight[3],
      }}
    >
      <Typography
        sx={{
          width: "190px",
          color: theme.palette.primary.greyPrimary,
          fontSize: theme.typography.customFontSize[2],
          fontWeight: theme.typography.customFontWeight[0],
          fontFamily: theme.typography.fontFamily,
          mr: "10px"
        }}
      >
        {label}
      </Typography>

      <RadioGroup
        row
        value={value ? "enable" : "disable"}
        onChange={(e) => onChange(e.target.value === "enable")}
      >
        {["Enable", "Disable"].map((option) => (
          <FormControlLabel
            key={option}
            value={option.toLowerCase()}
            control={
              <Radio
                icon={<UnCheckedIconIcon />}
                checkedIcon={<CheckedIcon />}
              />
            }
            label={option}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: theme.typography.customFontSize[2],
                color: theme.palette.primary.greyPrimary,
              },
            }}
            disabled={!showEditGeneral}
          />
        ))}
      </RadioGroup>
    </Box>
  );
};